import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GroupMembershipDialogComponent } from '@main-client/src/app/group-membership-dialog/group-membership-dialog.component';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

@Injectable()
export class GroupMembershipDialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(data: {
    account: Account;
    group: Group;
    onUpdate?: (updatedAccount: Account) => any;
  }) {
    return this.dialog.open(GroupMembershipDialogComponent, {
      data,
      maxWidth: '500px',
      width: '95vw',
    });
  }
}
